import { useState, useEffect } from 'react';
import { Flex } from './TremorCompat';
import { IconButton, InputPicker, Text } from 'rsuite';
import {
  MdOutlineSchedule as IconClock,
  MdOutlineSettings as IconSettings,
  MdOutlineAddCircle as IconMore,
  MdOutlineRemoveCircle as IconLess,
} from 'react-icons/md';

import { DisableEnableOptions } from '../constants';
import { COLOURS } from '../styles';
import { isALight } from './Common';
import { DisplayIcon } from './DisplayIcon';
import { DisplayItem } from './DisplayItem';
import { DisplayNameInputItem } from './DisplayNameInputItem';
import { Display2ValueToggleItem } from './Display2ValueToggleItem';
import { DisplayLightSettings } from './DisplayLightSettings';
import { DisplayTimePickerItem } from './DisplayTimePickerItem';
import { devLog } from '../utils/devLog';

export const DisplaySocketItem = ({
  name_register,
  tc,
  type_register,
  icon,
  options,
  onChange,
  onChangeName,
  disabled,
  time_enable_register,
  socket_setting,
  time_1_start,
  time_1_stop,
  time_2_start,
  time_2_stop,
  onTimeChange,
}) => {
  const [value, setValue] = useState(/** @type {any} */ (null));
  const [showMore, setShowMore] = useState(false);

  // const [Modevalue, setModeValue] = useState(null);
  const updatePickerValue = (value, event) => {
    devLog(event, value);
    setValue(value);
    onChange(type_register, value);
  };

  useEffect(() => {
    setValue(type_register.value);
  }, [type_register.value]);

  return (
    <>
      <Flex justifyContent="start" className="space-x-4">
        <DisplayIcon icon={icon} />
        <Text>{type_register.title}</Text>

        <div
          style={{
            display: 'block',
            width: '30%',
          }}
        >
          <InputPicker
            block
            cleanable={false}
            searchable={false}
            placement="autoVerticalStart"
            data={options}
            value={value}
            onChange={updatePickerValue}
            disabled={disabled}
          />
        </div>
        <div
          style={{
            display: 'block',
            width: '70%',
          }}
        >
          {name_register !== undefined ? (
            <DisplayNameInputItem register={name_register} onChange={onChangeName} borderOff={true} />
          ) : (
            ' '
          )}
        </div>
        <IconButton
          appearance="primary"
          color="blue"
          size="sm"

          icon={showMore ? <IconLess /> : <IconMore />}
          onClick={() => setShowMore(!showMore)}
        />
      </Flex>
      {isALight(type_register)
        ? showMore && (
            <DisplayLightSettings
              register={socket_setting}
              icon={IconSettings}
              onChange={onChange}
              disabled={disabled}
            />
          )
        : showMore && <DisplayItem register={socket_setting} icon={IconSettings} />}

      {showMore && (
        <Display2ValueToggleItem
          register={time_enable_register}
          icon={IconClock}
          options={DisableEnableOptions}
          onChange={onChange}
          tc={COLOURS.default}
          disabled={disabled}
        />
      )}

      {/* <Flex
          justifyContent="center"
          alignItems="center"
          className="space-x-2" >
          <div style={{
            display: "block",
            width: "50%"
          }}>
            {isALight()?}
          </div>
          <div style={{
            display: "block",
            width: "50%"
          }}>

          </div>
      </Flex> */}

      {showMore && (
        <Flex justifyContent="center" alignItems="center" className="space-x-2">
          <div
            style={{
              display: 'block',
              width: '50%',
            }}
          >
            <DisplayTimePickerItem
              register={time_1_start}
              icon={IconClock}
              onChange={onTimeChange}
              disabled={disabled}
            />
          </div>
          <div
            style={{
              display: 'block',
              width: '50%',
            }}
          >
            <DisplayTimePickerItem register={time_1_stop} onChange={onTimeChange} disabled={disabled} />
          </div>
        </Flex>
      )}
      {showMore && (
        <Flex justifyContent="center" alignItems="center" className="space-x-2">
          <div
            style={{
              display: 'block',
              width: '50%',
            }}
          >
            <DisplayTimePickerItem
              register={time_2_start}
              icon={IconClock}
              onChange={onTimeChange}
              disabled={disabled}
            />
          </div>
          <div
            style={{
              display: 'block',
              width: '50%',
            }}
          >
            <DisplayTimePickerItem register={time_2_stop} onChange={onTimeChange} disabled={disabled} />
          </div>
        </Flex>
      )}
    </>
  );
};
